export default "__VITE_ASSET__afb7f556__"